interface PeopleWithCircuitsInsideCircleSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PeopleWithCircuitsInsideCircleSVG = ({
  color,
  style,
}: PeopleWithCircuitsInsideCircleSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="52"
    viewBox="0 0 50 52"
    fill="none"
  >
    <g clipPath="url(#clip0_1586_46492)">
      <path
        d="M34.5 20.0001C35.8807 20.0001 37 18.8808 37 17.5001C37 16.1194 35.8807 15.0001 34.5 15.0001C33.1193 15.0001 32 16.1194 32 17.5001C32 18.8808 33.1193 20.0001 34.5 20.0001Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M17 18.0001C18.6569 18.0001 20 16.657 20 15.0001C20 13.3433 18.6569 12.0001 17 12.0001C15.3431 12.0001 14 13.3433 14 15.0001C14 16.657 15.3431 18.0001 17 18.0001Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M26 14.0001C27.6569 14.0001 29 12.657 29 11.0001C29 9.34327 27.6569 8.00012 26 8.00012C24.3431 8.00012 23 9.34327 23 11.0001C23 12.657 24.3431 14.0001 26 14.0001Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M26 14.0001V33.0001"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M20 16.0001L23 19.6013V25.0001"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M16.5 26.0001C17.8807 26.0001 19 24.8808 19 23.5001C19 22.1194 17.8807 21.0001 16.5 21.0001C15.1193 21.0001 14 22.1194 14 23.5001C14 24.8808 15.1193 26.0001 16.5 26.0001Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M33 20.0001L30 22.8579V30.0001"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M18 25.0001L21 29.4446V33.0001"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M28.2552 38.7569C28.2552 40.452 27.4121 43.3598 24.8815 43.3598C22.3508 43.3598 21.5078 40.452 21.5078 38.7569C21.5078 37.0618 23.0186 35.6888 24.8815 35.6888C26.7444 35.6888 28.2552 37.0634 28.2552 38.7569Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3173 44.7621C19.4376 45.6666 18.1357 47.5975 18.1357 49.8411V51.8829H31.6274V49.8411C31.6274 47.5975 30.3255 45.6666 28.4458 44.7621"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.137 38.7569C18.137 40.452 17.294 43.3598 14.7633 43.3598C12.2327 43.3598 11.3896 40.452 11.3896 38.7569C11.3896 37.0618 12.9004 35.6888 14.7633 35.6888C16.6262 35.6888 18.137 37.0634 18.137 38.7569Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1992 44.7621C9.31948 45.6666 8.01758 47.5975 8.01758 49.8411V51.8829H15.6064"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.6289 38.7569C31.6289 40.452 32.4719 43.3598 35.0026 43.3598C37.5332 43.3598 38.3763 40.452 38.3763 38.7569C38.3763 37.0618 36.8655 35.6888 35.0026 35.6888C33.1397 35.6888 31.6289 37.0634 31.6289 38.7569Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.5665 44.7621C40.4461 45.6666 41.748 47.5975 41.748 49.8411V51.8829H34.1592"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.30371 13.821C9.54634 7.47374 16.7327 3.29926 24.8826 3.29926C37.923 3.29926 48.4938 13.9843 48.4938 27.1658C48.4938 33.5207 46.0363 39.2963 42.0284 43.574"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.77187 43.611C3.74419 39.3302 1.27148 33.5392 1.27148 27.1658C1.27148 22.2223 2.75785 17.6318 5.30374 13.8225"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1586_46492">
        <rect width="55" height="52" fill={color} transform="translate(-1)" />
      </clipPath>
    </defs>
  </svg>
);

export default PeopleWithCircuitsInsideCircleSVG;
